<script>
	import {
		Button,
		Col,
		Container,
		IconButton,
		Modal,
		Row,
		Slider,
		Text,
	} from '@Shelly/shelly-design-system';
	import { get_gen_2_component_channel_structure, real_id } from '../../helpers/interface_helpers';
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceStatus,
	} from 'src/stores/device-runtime/status-selectors';
	import { format } from 'svelte-i18n';
	import { createEventDispatcher } from 'svelte';

	export let showModal, value, index, device;

	$: statusStore = getDeviceStatus(device?.id);

	const dispatch = createEventDispatcher();
	const handle_save = async () => {
		showModal = false;
		dispatch('save', { index, value });
	};
	const get_current_position = async (i, favorite) => {
		value = $statusStore[get_gen_2_component_channel_structure(device)].current_pos;
	};
	const onCloseModal = () => (showModal = false);

	const a11yProps = {
		sliderValueText: $format('current_position_value', {
			values: { value: value },
			default: `Current position value is ${value}`,
		}),
		ariaLabel: $format('collapse_title_set_position'),
		ariaLabelValue: $format('current_position_value', {
			values: { value: value },
			default: `Current position value is ${value}`,
		}),
	};
</script>

<Modal
	on:close={onCloseModal}
	{showModal}
	title={$format('collapse_title_set_position')}
	backdropClose={false}
>
	<svelte:fragment slot="content">
		<Container padding="0">
			<Text />
			<Row class="width-full">
				<Col xs="11">
					<Slider
						id="slider-2nfvgrs"
						{a11yProps}
						title={$format('label_position')}
						bind:value
						type="horizontal"
					/>
				</Col>
				<Col xs="1">
					<IconButton
						aria-label={$format('button_get_current_position', {
							default: 'Get current position',
						})}
						class="ml-s mt-m"
						icon="fas fa-crosshairs"
						on:click={get_current_position}
					/>
				</Col>
			</Row>
		</Container>
	</svelte:fragment>
	<div class="d-flex justify-content-end" slot="footer">
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			size="l"
			on:click={onCloseModal}
		>
			{$format('button_cancel')}
		</Button>
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			responsiveSize={{
				sm: 'm',
			}}
			size="l"
			on:click={handle_save}
		>
			{$format('button_save')}
		</Button>
	</div>
</Modal>
